/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddFormulasRequestDto
 */
export interface AddFormulasRequestDto {
    /**
     * Array of formula IDs to add to the prescription
     * @type {Array<string>}
     * @memberof AddFormulasRequestDto
     */
    formulaIds: Array<string>;
}

/**
 * Check if a given object implements the AddFormulasRequestDto interface.
 */
export function instanceOfAddFormulasRequestDto(value: object): value is AddFormulasRequestDto {
    if (!('formulaIds' in value) || value['formulaIds'] === undefined) return false;
    return true;
}

export function AddFormulasRequestDtoFromJSON(json: any): AddFormulasRequestDto {
    return AddFormulasRequestDtoFromJSONTyped(json, false);
}

export function AddFormulasRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFormulasRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'formulaIds': json['formulaIds'],
    };
}

export function AddFormulasRequestDtoToJSON(json: any): AddFormulasRequestDto {
    return AddFormulasRequestDtoToJSONTyped(json, false);
}

export function AddFormulasRequestDtoToJSONTyped(value?: AddFormulasRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formulaIds': value['formulaIds'],
    };
}

